import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { RnfiModule } from '@rnficonfig/rnfi.module';
import { Relipayconfig } from '@rnficonfig/index';
import { importProvidersFrom } from '@angular/core';
import { routes } from './app-routing.module';
import { LOCATION_INITIALIZER } from '@core/location-required/location-required.factory';
import { locationInterceptor } from '@core/location-required/location.interceptor';
import { ENCRYPTION_INITIALIZER } from '@core/encryption-module/encryption.factory';
import { encryptionInterceptor } from '@core/encryption-module/encryption.interceptor';
import { apiRequestTokenInterceptor } from '@core/interceptors/apiRequestToken-interceptor';
import { provideLoading } from '@core/loading';
import { httpErrorHandlingInterceptor } from '@core/interceptors/error-handling/http-error-handling.interceptor';
import { attachCancelInterceptor } from '@core/interceptors/error-handling/abort-ongoing-requests/attachAbortSignal.interceptor';
import { uploadImageInterceptor } from '@core/interceptors/uploadImage-interceptor';
import { buzzRnfiInterceptor } from '@core/interceptors/BuzzRnfi-interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'disabled',
      anchorScrolling: 'enabled'
    }), withHashLocation()),
    provideAnimations(),
    LOCATION_INITIALIZER,
    ENCRYPTION_INITIALIZER,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideLoading(),
    // ✅ Use functional HTTP client with interceptors
    provideHttpClient(
      withInterceptors([
        locationInterceptor,
        apiRequestTokenInterceptor,
        attachCancelInterceptor,
        uploadImageInterceptor,
        buzzRnfiInterceptor,
        httpErrorHandlingInterceptor,
        encryptionInterceptor
      ])
    ),

    // ✅ Register interceptors (same as in AppModule)
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: NetworkInterceptor,
    //   multi: true,
    // },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: HttpInterceptorInterceptor,
    //   multi: true,
    // },

    // ✅ Provide RNFI configuration
    importProvidersFrom(RnfiModule.forRoot(Relipayconfig)),

    // ✅ Toastr configuration
    provideToastr({
      maxOpened: 1,
      preventDuplicates: true,
      closeButton: true,
      // positionClass: 'toast-top-right',
      // timeOut: 0,
      // tapToDismiss: false,
    }),

    DatePipe,
  ],
};
